import { MenuItem, SubMenu } from "react-pro-sidebar";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import accounting from "../../../images/newDesign/accounting.svg";
import { isLinkActive } from "../../sidebar/Sidebar.shared";
import { constants } from "../../../common/constants/constants";
import CacheData from "../../../common/utils/cacheData";
import BllinkTime from "../../../common/utils/time";

/**
 * @param {string | number} buildingId
 * @param {boolean} isGreenInvoiceOn
 * @return {JSX.Element|null}
 * @constructor
 */
export default function AccountingSidebarMenu({ buildingId, isGreenInvoiceOn }) {
    const { t } = useTranslation();
    const currentYear = BllinkTime.getCurrentYear();
    const currentMonth = BllinkTime.getCurrentMonth();
    const localBuildingId = useSelector(state => buildingId ?? state.buildings.buildingID ?? CacheData.fetchCache('currentBuilding'));

    return (
        <SubMenu
            title={t('buildings.nav_bar_accounting')}
            icon={<img src={accounting} alt={t('buildings.nav_bar_accounting')}/>}>
            <MenuItem
                active={isLinkActive(`/${constants.pages.bankAdjustmentsUrl}/:buildingID/:month/:year`)}
                className="mobile-hide"
            >
                <NavLink
                    className="nav-link"
                    to={`/${constants.pages.bankAdjustmentsUrl}/${localBuildingId}/${currentMonth}/${currentYear}`}
                >
                    {t('buildings.nav_bar_bank_reconciliation')}
                </NavLink>
            </MenuItem>
            <MenuItem
                active={isLinkActive(`/${constants.pages.balanceReportUrl}/:buildingID`)}
            >
                <NavLink
                    className="dropdown-link"
                    to={`/${constants.pages.balanceReportUrl}/${localBuildingId}`}
                >
                    {t('buildings.nav_bar_reports_expenses_balance')}
                </NavLink>
            </MenuItem>
            {isGreenInvoiceOn && (
                <MenuItem>
                    <NavLink
                        className="dropdown-link"
                        to={{ pathname: `https://auth.greeninvoice.co.il/signin` }} target="_blank">
                        {t('reports.accounting_service')}
                    </NavLink>
                </MenuItem>
            )}
        </SubMenu>
    )
}
